import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IEmployerCheckCreatedWebhookRequestBody } from "./employerCheckCreatedWebhook.jsonschema";

export const employerCheckCreatedWebhook = (axios: IAxiosInstance) => {
  return async (
    checkCreatedWebhook: string,
    userType: string,
    test: boolean
  ) => {
    const webhookBody: IEmployerCheckCreatedWebhookRequestBody = {
      check_created_webhook: checkCreatedWebhook,
      user_type: userType,
      test,
    };
    const response = await axios.noRetry.post<unknown>(
      `/api/testCheckCreatedWebhook`,
      webhookBody
    );

    const { data } = response;

    return data;
  };
};
